import React, { useCallback, useMemo, useState } from 'react';
import DataGrid from '../../../UI/DataGrid/DataGrid';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { convertiUtsToDateHour } from '../../../InterfaceClient/Tabs/Alarmes/TableauAlarmesClient/TableauAlarmesClient';
import { Sensor } from '../../../../types/types';

// Définition des interfaces

interface Props {
  selectionnerLignes?: any;
  defaultSorted?: Array<{ dataField: string; order: string }>;
  data: Sensor[];
}

const COLUMN_CONFIG: Array<[string, string, number]> = [
  ['detection_timestamp', 'detection_timestamp', 180],
  ['timestamp_last_value', 'timestamp_last_value', 180],
  ['position_in_sensor', 'position_in_sensor', 150],
  ['prefix', 'prefix', 140],
];

const createColumn = (field: string, labelKey: string, width: number) => {
  const baseColumn = {
    field,
    headerName: checkMot(labelKey),
    width,
    sortable: true,
  };

  if (field === 'detection_timestamp' || field === 'timestamp_last_value') {
    return {
      ...baseColumn,
      valueFormatter: (value?: number) =>
        value ? convertiUtsToDateHour(value) : '',
    };
  }

  return baseColumn;
};

const TableauComposantMaintenance = (props: Props) => {
  const [selectionModel, setSelectionModel] = useState<any[]>([]);

  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width]) =>
        createColumn(field, labelKey, width)
      ),
    []
  );

  const handleSelectionModelChange = useCallback(
    (newSelection: any[]) => {
      setSelectionModel(newSelection);
      if (props.selectionnerLignes?.onSelect && newSelection.length > 0) {
        const selectedRow = props.data.find(
          (row) => (row as any).id === newSelection[0]
        );
        if (selectedRow) {
          props.selectionnerLignes.onSelect(selectedRow, true);
        }
      }
    },
    [props.data, props.selectionnerLignes]
  );
  return (
    <DataGrid
      rows={props.data}
      columns={columns}
      getRowId={(row: any) => row.id}
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={handleSelectionModelChange}
      disableMultipleRowSelection
    />
  );
};

export default TableauComposantMaintenance;
